import { languages } from '../../layout/i18n/Languages';
import { Clickable } from 'dg-web-shared/ui/Clickable';
import { css } from '@emotion/css';
import { Typo } from 'dg-web-shared/ui/typo.ts';
import { Colors } from 'dg-web-shared/ui/vars';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { languageFromString } from 'dg-web-shared/lib/Localized.ts';

export function LanguageSwitch({
    languageSwitchOpen,
    setLanguageSwitchOpen,
}: {
    languageSwitchOpen: boolean;
    setLanguageSwitchOpen: (open: boolean) => void;
}) {
    const { language, setLanguage } = useLanguage();
    return (
        <div
            className={css({
                display: 'flex',
                height: '32px',
                gap: '2px',
            })}
        >
            {languages.map(lng => {
                const isCurrent = language === lng.shortcut;
                if (languageSwitchOpen || isCurrent) {
                    return (
                        <Clickable
                            element="div"
                            className={css({
                                ...Typo.caption,
                                width: '60px',
                                lineHeight: '32px',
                                textAlign: 'center',
                                background: Colors.blue,
                                borderRadius: '2px',
                                color: Colors.rgba(
                                    Colors.action_b,
                                    isCurrent ? 1 : 0.6,
                                ),
                            })}
                            onClick={
                                languageSwitchOpen
                                    ? () => {
                                          setLanguage(
                                              languageFromString(lng.shortcut),
                                          );
                                          setLanguageSwitchOpen(false);
                                      }
                                    : () => setLanguageSwitchOpen(true)
                            }
                            key={lng.shortcut}
                        >
                            {lng.shortcut.toLocaleUpperCase()}
                        </Clickable>
                    );
                }
                return null;
            })}
        </div>
    );
}
